import { FormControl, Input, InputProps } from '@chakra-ui/react';
import { Control, Controller } from 'react-hook-form';

export interface EditableCellProps<T>
  extends React.HTMLAttributes<HTMLElement> {
  editing: boolean;
  dataIndex: string;
  inputType: InputProps['type'];
  control: Control;
  record: T;
  index?: number;
  children?: React.ReactNode;
  inputProps?: InputProps;
}

export const EditableCell = <T,>(props: EditableCellProps<T>) => {
  const {
    title: _title,
    record: _record,
    editing,
    dataIndex,
    inputType,
    inputProps,
    children,
    control,
    ...restProps
  } = props;

  return (
    <td {...restProps}>
      {editing ? (
        <FormControl>
          <Controller
            control={control}
            name={dataIndex}
            render={({ value, onChange }) => (
              <Input
                type={inputType}
                borderColor='gray.500'
                size='sm'
                value={value}
                _hover={{ borderColor: 'gray.600', ...inputProps?._hover }}
                _focus={{ boxShadow: 'md', ...inputProps?._focus }}
                {...inputProps}
                onChange={(e) => {
                  onChange(e);
                  inputProps?.onChange?.(e);
                }}
                spellCheck={false}
              />
            )}
          />
        </FormControl>
      ) : (
        children
      )}
    </td>
  );
};
